import React from "react";
import "./index.scss";
import logo from "./img/PC0-1.png";
import { Link } from "react-scroll";
import BurgerMenuIcon from "../BurgerMenuIcon";

class Header extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      menuActive: false,
      navActive: ""
    };
    this.handlerNavClick = this.handlerNavClick.bind(this);
    this.handlerLinkClick = this.handlerLinkClick.bind(this);
  }
  handlerNavClick() {
    this.setState(state => ({
      menuActive: !state.menuActive,
      navActive: state.navActive ? "" : "active"
    }));
  }
  handlerLinkClick() {
    this.setState({
      menuActive: false,
      navActive: ""
    });
  }
  render() {
    const links = menu.map((link, i) => (
      <Link
        key={i}
        href="#"
        className="nav-link"
        activeClass="active"
        to={link.to}
        offset={this.props.height * -1}
        duration={500} spy smooth
        onClick={this.handlerLinkClick}
      >
        {link.name}
      </Link>
    ));
    return (
      <header className="header" ref={this.props._header}>
        <Link
          href="#"
          className="logo"
          to="kvAd"
          offset={this.props.height * -1}
          duration={500} spy smooth
        >
          <img src={logo} alt="samsung and "/>
        </Link>
        <nav className={`nav ${this.state.navActive}`}>
          {links}
        </nav>
        <BurgerMenuIcon
          active={this.state.menuActive}
          style={{top: this.props.height / 2}}
          onClick={this.handlerNavClick}
        />
      </header>
    )
  }
}

export default Header;

let menu = [
  {
    name: '拒絕再當過敏兒',
    to: 'kvAd',
    offset: null
  },
  {
    name: '過敏原不可不知',
    to: 'section1',
    offset: null
  },
  {
    name: '過敏的影響',
    to: 'section1-2',
    offset: null
  },
  {
    name: '媽媽們怎麼說',
    to: 'section2',
    offset: null
  },
  {
    name: '抗過敏必備',
    to: 'section3',
    offset: null
  }
];
